import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { Util } from '@libs/utilities/util';


/**------------------------------------------------------
 * Copy Text
 * ---------
 * Copy text to clipboard
 *
 * Example:
 * --------
 * 	<i [ngCopy]="..."> ... </i>
 */
@Directive({
    selector: '[ngCopy]',
    standalone: false
})
export class NgCopyDirective {

	@Input()  ngCopy				: string			   = '';
	@Output() readonly copySuccess	: EventEmitter<string> = new EventEmitter<string>();
	@Output() readonly copyFail		: EventEmitter<string> = new EventEmitter<string>();

	@HostListener('click', ['$event'])
	public onClick(event: Event): void {

		//0 - check for data
		if (Util.String.isEmpty(this.ngCopy)) throw new Error(`NgCopyDirective => onClick => FATAL ERROR: copy string was not provided`);

		//1 - prevent propagating from
		event.stopPropagation();

		//2 - write on the clipboard
		navigator.clipboard.writeText(this.ngCopy)
			.then(() => {
				this.copySuccess.emit(this.ngCopy);
			})
			.catch((error: any) => {
				this.copyFail.emit(error);
			});
	}
}
